// extracted by mini-css-extract-plugin
export default {"tier4AccountBtnTooltip":"Tier4AccountBtnTooltip_tier4AccountBtnTooltip__oDod+"};